import { Home } from 'lucide-react';
import { StepHeader } from '~/components/forms/StepHeader';
import { FamilyInfoChunk } from '~/components/form-chunks/FamilyInfoChunk';

/**
 * FamilyInfoStep - Edit family information including address, guardians, contacts.
 * Delegates to FamilyInfoChunk for the actual form content.
 */
export function FamilyInfoStep({ formData, updateFormData, onReviewComplete }: any) {
  const familyInfo = formData?.familyInfo || {};

  const handleUpdate = (updatedFamilyInfo: any) => {
    updateFormData('familyInfo', updatedFamilyInfo);
  };

  return (
    <div className="space-y-6">
      <StepHeader
        icon={Home}
        title="Family Information"
        description="Please review and update your family's contact information."
      />

      <FamilyInfoChunk
        familyInfo={familyInfo}
        onUpdate={handleUpdate}
        onReviewComplete={onReviewComplete}
      />
    </div>
  );
}

export default FamilyInfoStep;
